
/* injects from baggage-loader */

import React from "react";
import {keyboardNumbers} from "../../../../dev/constants/keyboardNumbers";
import {t} from "../../../../dev/helpers/translator";
import PropTypes from 'prop-types';
import Config from '../../../../dev/config/main';
import {BETSLIP_TYPE_SINGLE} from "../../../../dev/helpers/sport/betslip";
import StaticStake from "../staticStake";

class Keyboard extends React.Component {
    constructor(props) {
        super(props);
        this.updateValue = this.updateValue.bind(this);
    }

    handleNumberFieldClick (num) {
        return (event) => {
            event.preventDefault();
            ((this.currentValue || "").length < 10) && this.applyChange(this.updateValue([this.currentValue, num].join("")));
        };
    }
    updateValue (value = "") {
        if (this.props.settings.processHandler && value.indexOf(".") !== value.length - 1) {
            value = this.props.settings.processHandler(value);
        }
        let strValue = value.toString();
        //!isNaN(+value) && strValue.indexOf(".") !== strValue.length - 1 && (strValue = (+strValue).toString());
        this.currentValue = strValue;
        console.log(this.currentValue, 'current')
        return this.currentValue;
    }
    handleClick (type) {
        return (event) => {
            switch (type) {
                case undefined: {
                    if (!this.currentValue) break;

                    event.preventDefault();
                    let update = this.currentValue.toString().split("");
                    update.pop();
                    this.applyChange(this.updateValue(update.join("")));
                    break;
                }
                case ".":
                    event.preventDefault();
                    ((this.currentValue || "").length < 10) && this.currentValue.indexOf(".") === -1 && this.applyChange(this.updateValue([this.currentValue || 0, "."].join("")));
                    break;
                case true:
                    if (!this.props.settings) {
                        return false;
                    }
                    this.props.settings.onCloseCallback && typeof this.props.settings.onCloseCallback === "function" ? this.props.settings.onCloseCallback() : this.props.settings.onCloseCallback;
                    break;
            }
        };
    }
    applyChange (value = "") {
        this.props.settings.changeHandler && this.props.settings.changeHandler(value);
    }
    UNSAFE_componentWillMount () {
        document.body.setAttribute("virtual-keyboard", "opened");
        this.currentValue = this.props.settings && this.props.settings.currentValue;
        setTimeout(() => {
            this.props.settings && this.props.settings.onOpenCallback && this.props.settings.onOpenCallback(this.props.settings.e);
        });
    }
    componentWillUnmount () {
        document.body.removeAttribute("virtual-keyboard");
    }
    fillNumbers () {
        return keyboardNumbers.map((num) => (<li key={num} onClick={this.handleNumberFieldClick(num)}><span>{num}</span></li>));
    }
    render () {
        return (
            <div className={`virtual-keyboard-wrapper ${this.props.betSlipType === BETSLIP_TYPE_SINGLE && "single-betslip-keyboard"}`}>
                <div className="virtual-keyboard-m">
                    {
                        Config.staticStakeInKeyboard &&
                            <StaticStake
                                setStake={(val) => this.applyChange(this.updateValue(val.toString()))}
                            />
                    }
                    <div>
                        <ul className="key-numbers-m">
                            {this.fillNumbers()}
                        </ul>
                        <ul className="key-simbols-m">
                            {!Config.main.removeDotFromVirtualKeyBoard && <li onClick={this.handleClick(".")}><span>.</span></li>}
                            <li onClick={this.handleClick()}><span/></li>
                            <li onClick={this.handleClick(true)}><span>{t("Done")}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

Keyboard.propTypes = {
    settings: PropTypes.object,
    bindToElement: PropTypes.bool,
    betSlipType: PropTypes.number
};

export default Keyboard;